(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
        .state('planned-shipment', {
            // parent: 'entity',
            parent: 'app',
            url: '/planned-shipment',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccstrtest1App.plannedShipment.home.title'
            },
            views: {
                // 'content@': {
                'planned-shipment@': {
                    templateUrl: 'app/entities/planned-shipment/planned-shipments.html',
                    controller: 'PlannedShipmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('plannedShipment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('planned-shipment-detail', {
            // parent: 'entity',
            parent: 'app',
            url: '/planned-shipment/{id}',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccstrtest1App.plannedShipment.detail.title'
            },
            views: {
                // 'content@': {
                'planned-shipment-detail@': {
                    templateUrl: 'app/entities/planned-shipment/planned-shipment-detail.html',
                    controller: 'PlannedShipmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('plannedShipment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PlannedShipment', function($stateParams, PlannedShipment) {
                    return PlannedShipment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'planned-shipment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('planned-shipment-detail.edit', {
            // parent: 'planned-shipment-detail',
            parent: 'app',
            // url: '/detail/edit',
            url: '/planned-shipment/detail/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/planned-shipment/planned-shipment-dialog.html',
                    controller: 'PlannedShipmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PlannedShipment', function(PlannedShipment) {
                            return PlannedShipment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('planned-shipment.new', {
            // parent: 'planned-shipment',
            parent: 'app',
            // url: '/new',
            url: '/planned-shipment/new',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/planned-shipment/planned-shipment-dialog.html',
                    controller: 'PlannedShipmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                shipPeriod: null,
                                qtyBales: null,
                                qtyMts: null,
                                shipMonth: null,
                                shipYear: null,
                                priceModel: null,
                                priceDisplay: null,
                                fixedPrice: null,
                                fixedPriceType: null,
                                fixedPriceUnitType: null,
                                fixedPriceValue: null,
                                onCallPrice: null,
                                onCallPriceType: null,
                                onCallPriceUnitType: null,
                                onCallOnOff: null,
                                onCallMonth: null,
                                onCallYear: null,
                                onCallIndex: null,
                                balanceBales: null,
                                balanceMts: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('planned-shipment', null, { reload: 'planned-shipment' });
                }, function() {
                    $state.go('planned-shipment');
                });
            }]
        })
        .state('planned-shipment.edit', {
            // parent: 'planned-shipment',
            parent: 'app',
            // url: '/{id}/edit',
            url: '/planned-shipment/{id}/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/planned-shipment/planned-shipment-dialog.html',
                    controller: 'PlannedShipmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PlannedShipment', function(PlannedShipment) {
                            return PlannedShipment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('planned-shipment', null, { reload: 'planned-shipment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('planned-shipment.delete', {
            // parent: 'planned-shipment',
            parent: 'app',
            // url: '/{id}/delete',
            url: '/planned-shipment/{id}/delete',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/planned-shipment/planned-shipment-delete-dialog.html',
                    controller: 'PlannedShipmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PlannedShipment', function(PlannedShipment) {
                            return PlannedShipment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('planned-shipment', null, { reload: 'planned-shipment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });

        $stickyStateProvider.enableDebug( true );
        
    }

})();
